/* CreateAction.js */

"use strict";
const Registrations = require("../../../../../RegistrationNamespaces");
const CreateComponent = require("./CreateComponent");
const _ = require("lodash");

class CreateAction {
    constructor(logger, gameEditor, modalUserFeedback, OsUpgradePlan, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osPlan = new OsUpgradePlan(userSession.activeOrganization.id);

        this._modalUserFeedback = this._gameEditor._modalUserFeedback;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }

    run() {
        return this._modalUserFeedback
            .displayCustom(new CreateComponent(this._logger), {dontHide: true})
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createPlan(result.trim()).catch((err) => {
                    this._logger.warn({error: err}, "CreateAction._createPlan() error.");
                    return this._modalUserFeedback.displayError(err);
                });
            })
            .then((result) => {
                if (_.isEmpty(result.osmOptions)) {
                    result.setOsmOptions(
                        _.get(this._gameEditor, "_osPlanPrefs._pristineProperties.osmOptions", {})
                    );
                    return result.update();
                }
                return Promise.resolve(result);
            })
            .then((result) => {
                let editorState = {
                    fqn: Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
                    viewState: {createMode: true},
                };
                let launchOpts = {
                    id: result.id,
                    title: result.properties.name,
                };
                this._modalUserFeedback.hideDisplayed();
                this._gameEditor.launchPlanEditor(editorState, launchOpts);
                if (
                    typeof this._activeView.resetSelection === "function" &&
                    typeof this._activeView.loadAndScrollTo === "function"
                ) {
                    this._activeView.resetSelection([result.id]);
                    this._activeView.loadAndScrollTo(result.id);
                }
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn(
                    {error: err},
                    "CreateAction.run() - Either error or cancellation"
                );
            });
    }

    _createPlan(name) {
        // Defaults
        this._osPlan.name = name;
        this._osPlan.description = "";
        this._osPlan.action = "TRANSFER";
        this._osPlan.groupedBy = "detectedSku";
        if (this._gameEditor.isOsTransferAutoCaptured) {
            this._osPlan.snapshotType = "POST";
        } else {
            this._osPlan.snapshotType = "NONE";
        }
        return this._osPlan.create();
    }
}

module.exports = CreateAction;

CreateAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "gameEditor.activeView",
];

CreateAction.$displayDetails = {
    type: "Action",
    name: "CreateAction",
    icon: "osmanager.add_os_plan",
    shown: true,
    title: "Add OS Plan",
    order: 2,
};
